import { IonCard, IonCardHeader, IonCardTitle, IonCol, IonIcon, IonRow } from "@ionic/react"
import { Glob, useLoc } from "functions/Language"
import { FC, PropsWithChildren } from "react"

import "components/OverviewCard.css"
import { chevronForwardOutline } from "ionicons/icons"


export const OverviewCard : FC<PropsWithChildren<{
  title: string,
  href?: string,
}>> = (props) => {
  const link = useLoc(glob)

  return <IonCard routerLink={props.href} style={{marginBottom: "6px"}}>
    <IonCardHeader>
      <IonCardTitle>
        {props.title}
      </IonCardTitle>
    </IonCardHeader>
    {/* <IonCardContent> ?*/}
    {props.children}
    {props.href !== undefined &&
      <IonRow>
        <IonCol style={{color: "var(--ion-color-primary)", display: "flex", flexDirection: "row-reverse", padding: "10px"}}>
          <span>
            {link.more}
            <IonIcon icon={chevronForwardOutline} />
          </span>
        </IonCol>
      </IonRow>
    }
  </IonCard>
}


const glob = Glob({
	en: {
		more: "See more",
	},
	cs: {
		more: "Zobrazit více",
	},
	pg: {
		more: "Mostrar mais",
	},
	es: {
		more: "Mostrar más",
	},
} as const);

